import { render, staticRenderFns } from "./AddBannerSectorComponent.vue?vue&type=template&id=62f439fe&scoped=true"
import script from "./AddBannerSectorComponent.vue?vue&type=script&lang=js"
export * from "./AddBannerSectorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f439fe",
  null
  
)

export default component.exports